import script from "./navbar-light.vue?vue&type=script&setup=true&lang=js"
export * from "./navbar-light.vue?vue&type=script&setup=true&lang=js"

import "./navbar-light.vue?vue&type=style&index=0&id=7747bc9a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7747bc9a"]])

export default __exports__